import $ from 'jquery';
import jQuery from 'jquery';
import Swiper from 'swiper/bundle';
import SwiperAnimation from '@cycjimmy/swiper-animation';
import AOS from 'aos';
import tooltipster from "tooltipster";
import parsley from 'parsleyjs';

require("./bootstrap");
require("./popper.min");
require("./jquery.animate-colors");
require("./jquery.easing.1.3");
require("./upd");

// Dynamic viewport units support fallback
function setDV() {
  window.requestAnimationFrame(function() {
    document.documentElement.style.setProperty('--dvw', (window.innerWidth  / 100) + 'px');
    document.documentElement.style.setProperty('--dvh', (window.innerHeight / 100) + 'px');
  });
}
window.addEventListener('resize', setDV);
setDV();


// Global loader
let globalLoader = new Promise(function(resolve, reject) {
  if (document.readyState === "complete") {
    resolve();
  } else {
    window.addEventListener("load", function onWindowLoad() {
      window.removeEventListener("load", onWindowLoad);
      resolve();
    });
  };
});


let ClipboardJS = require('clipboard');
const swiperAnimation = new SwiperAnimation();

const checkChanges = function()
{
    if ($('.simple-parallax-initialized').length) {
        $(".loader").slideUp();
    }
    else {
        setTimeout(checkChanges, 500);
    }
}

const isMobile = () => {
    return $(window).width() <= 1000;
}

const svgEffect = () => {
    $('.lot').show().addClass('animate__fadeIn');
}

const lotAnimation = (startTime) => {
    let arr = [],
        r = 0,
        mobile = isMobile(),
        duration = 200,
        elements = $(".lot").toArray();

    while(arr.length < 8){
        r = Math.floor(Math.random()*elements.length);
        if(arr.indexOf(r) === -1) arr.push(elements[r]);
    }

    setTimeout(() => {
        arr.forEach((element, index) => {
            setTimeout(() => {
                $('.lot').trigger('mouseleave');
                $(element).stop().trigger('mouseenter');
            }, duration);
            duration += 200;
        });
        setTimeout(() => {
            $('.lot').trigger('mouseleave');
        }, duration);
    }, startTime);
}

$(document).ready(function () {

    if(!isMobile()) {
        $('.tooltipster').tooltipster({
            theme: 'tooltipster-lot',
            contentCloning: true,
            contentAsHTML: true,
            delay: 0,
            animationDuration: 50,
            animation: 'grow',
        });
    }

    $('.tooltip-img').tooltipster({
        theme: 'tooltipster-img',
        contentCloning: true,
        contentAsHTML: true,
        delay: 0,
        animationDuration: 300,
        animation: 'fade',
        trigger: 'click',
        side: 'right'
    });



    $(function () {
        $('[data-toggle="popover"]').popover({
            delay: {
                "show": 500,
                "hide": 100
            },
            placement: "top"
        })
    })


    globalLoader.then(function() {
      $(".loader").slideUp(500, function() {
        let $svg = $('.lands-svg'),
            scroll = (1050 - $(window).width()) / 2;
            $svg.scrollLeft(scroll);
      });
    }, function() {});

    AOS.init({
        once: true,
        duration: 500,
        offset: 0,
    });

    $('.count').each(function () {
        $(this).prop('Counter',0).animate({
            Counter: $(this).text()
        }, {
            duration: 1000,
            easing: 'swing',
            step: function (now) {
                $(this).text(Math.ceil(now));
            }
        });
});

    if($('.project-page').length) {

        let stopAllVideos = function(el) {
          el.querySelectorAll('video').forEach(function(video) {
            video.pause();
            video.currentTime = 0;
          });
        };

        let playAllVideos = function(el) {
          el.querySelectorAll('video').forEach(function(video) {
            video.play().catch(function(error) {
              console.warn(error);
            });
          });
        };

        let handleSwiperVideos = function(swiper) {
          stopAllVideos(swiper.el);
          playAllVideos(swiper.slides[swiper.activeIndex]);
        };

        let gallery = new Swiper(".concept-gallery", {
            spaceBetween: 0,
            slidesPerView: 1,
            speed: 1000,
            autoplay: {
                delay: 10000,
            },
            pagination: {
                el: '.concept-gallery-pagination',
                clickable: true,
            },
            on: {
                init: function () {
                    this.el.parentElement.setAttribute("data-slide-index", this.activeIndex);
                    handleSwiperVideos(this);
                },
                slideChange: function () {
                    this.el.parentElement.setAttribute("data-slide-index", this.activeIndex);
                    handleSwiperVideos(this);
                },
            },
        });

        $('.concept-gallery-pagination').children().on('click', function(e) {
            gallery.autoplay.stop();
        });

        let districtSlider = new Swiper(".district-slider", {
            spaceBetween: 0,
            slidesPerView: 1,
            autoHeight: true,
            speed: 1000,
            fadeEffect: {
                crossFade: true
            },
            navigation: {
                nextEl: '.district-slider-next',
                prevEl: '.district-slider-prev',
            },
            pagination: {
                el: '.district-slider-pagination',
                clickable: true,
                renderBullet: function (index, className) {
                    let titles = [];
                    $(".district-slider .district-cont").each(function(i) {
                        titles.push($(this).data("title"));
                    });
                    return '<span class="' + className + '"><span class="bullet"></span><span class="text">'+ titles[index] +'</span></span>';
                },
            },
            on: {
                init: function () {
                    swiperAnimation.init(this).animate();
                },
                slideChange: function () {
                    swiperAnimation.init(this).animate();
                }
            }
        });

        $('.swiper-pagination-bullet').click(function(e) {
            return e.preventDefault
        })

    }

    let fileDownload = function (file) {
        if (file) {
            let link = document.createElement("a");
            link.download = 'download';
            link.href = file;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    }


    $(".download-file").click(function (e) {
        e.preventDefault();
        fileDownload($(this).data('file'));
    });

    $(".menu-open").click(function(){
        $(this).addClass("is-active");
        $(".menu").addClass("active");
    });

    $(".menu-close").click(function(){
        $(this).removeClass("is-active");
        $(".menu").removeClass("active");
    });

    $('.main-content-text-button').click(function(){
        let $button = $(this),
            less = $button.data('less'),
            full = $button.data('full');

        let text = ($('.full-text').is(':visible')) ? full : less;
        $button.siblings('.full-text').slideToggle(1000, 'easeOutExpo');
        $button.html(text)
    });

    let lastScrollTop = 0;
    let isProgrammaticScroll = false;

    $(window).scroll(function () {
        if(!$('.project-page').length) return;

        if($(window).scrollTop() > 100) {
            $("header").addClass("active black");
        } else {
            $("header").removeClass("active black");
        }

        let scrollTop = $(window).scrollTop(),
            scrollBottom = $(window).scrollTop() + $(window).height(),
            height = 0,
            scrollAdd = 0,
            $district = $('.district'),
            $districtImgAfter = $('.district-img-after'),
            scroll = (scrollTop > lastScrollTop) ? scrollBottom : scrollTop,
            $header = $('header');

        if($district.length) {
            if(scrollTop >= ($district.position().top - 300)) {
                height = (scrollTop / $district.position().top) * 100;
            }
            $districtImgAfter.stop().animate({
                height: height + "%"
            }, 1000);
        }


        if (scrollTop >= 100) {
            let currentSection = null;
            let minDistance = Infinity;

            $('body > div > section').each(function (i) {
                var gbr = this.getBoundingClientRect();

                if (gbr.top <= 0 && gbr.bottom > 100) {
                    let color = $(this).data('color'),
                        btn = $(this).data('btn');

                    $('body').stop().animate({
                        backgroundColor: color
                    }, 300);

                    if($(this).data('bg') == 'green') {
                        $(this).addClass('green');
                        $('body').addClass('green');
                    } else {
                        $('section, body').removeClass('green');
                    }

                    if(!isMobile()) {
                        $header.removeClass();
                        $header.addClass('fixed ' + $(this).data('header'));
                    }

                    $('.section-btn').removeClass('active');

                    if(btn) {
                        $(btn).addClass('active');
                    }
                }

                // Find the section that's currently in view or closest to the top
                if ($(this).position().top <= scrollTop + 100) {
                    let distance = Math.abs($(this).position().top - scrollTop);
                    if (distance < minDistance) {
                        minDistance = distance;
                        currentSection = $(this);
                    }
                }
            });

            // Completely skip ALL menu item updates during programmatic scroll
            if (!isProgrammaticScroll) {
                if (currentSection && currentSection.data('anchor')) {
                    $('.menu-list-item.active').removeClass('active');
                    $('.menu-list-item[data-scroll="' + currentSection.data('anchor') + '"]').addClass('active');
                }
            }

        } else {
            if(!isMobile()) {
                $header.removeClass();
            }
            $('section').removeClass('green');
            // Only update menu items if not programmatically scrolling
            if (!isProgrammaticScroll) {
                $('.menu-list-item.active').removeClass('active');
                $('.menu-list-item:first').addClass('active');
            }
        }

        lastScrollTop = scrollTop;

    }).scroll();

    $('.menu-list-item').click(function (e) {

        e.preventDefault();

        let scrollAnchor = $(this).attr('data-scroll'),
            $header = $('.header'),
            sec = 300,
            $anchor = $('section[data-anchor="' + scrollAnchor + '"]'),
            scrollPoint = $anchor.offset().top + 5,
            $clickedItem = $(this);

        // Immediately set flag to prevent scroll handler from interfering
        isProgrammaticScroll = true;

        $header.removeClass();
        $header.addClass($anchor.data('header'));

        $(".menu").toggleClass("active");

        setTimeout(() => {
            $('body,html').animate({
                scrollTop: scrollPoint
            }, 1000, 'easeInOutExpo', function() {
                // Only when scroll completes: remove from all and add to clicked item
                if ($clickedItem.length) {
                    $('.menu-list-item').removeClass('active');
                    $clickedItem.addClass('active');
                }
            });

        // Reset flag after scroll fully completes (sec delay + animation time + buffer)
        setTimeout(function() {
            isProgrammaticScroll = false;
        }, sec + 1000 + 500);
        }, sec);

        history.pushState(null, null, '#'+scrollAnchor);

        return false;

    });

    $('.lot.sale').click(function (e) {
        e.preventDefault();

        if($(this).hasClass('disabled')) return;

        const url = $(this).data('target'),
              $this = $(this),
              $lots = $('.lot'),
              $cont = $('.lots-item-cont');

        $(document).trigger('handle', [$cont, false]);
        $cont.empty();
        $lots.removeClass('active');
        $this.addClass('active');

        $.ajax({
            url: url,
            type: 'GET',
            success: function (response) {
                $('body').addClass('lot-open');
                $cont.append(response);
                $(document).trigger('handle', [$cont, true]);
                window.history.replaceState( {} , "", url );
            },
            error: function (jqXHR, textStatus, errorThrown) {
                $lots.removeClass('active');
                $('body').removeClass('lot-open');
                $(document).trigger('handle', [$cont, false]);
                $cont.empty();
            }
        });
    });

    $(document).on('click', '.lot-close', function (e) {
        $('.lot-item').addClass('animate__fadeOutRight');
        $('body').removeClass('lot-open');
        $('.lot').removeClass('active');
        window.history.replaceState( {} , "", $(this).data('url'));
    });

    $(document).on('click', '.lot-items-close', function (e) {
        $('.lot-items').addClass('animate__fadeOutRight');
        $('body').removeClass('lot-open');
        window.history.replaceState( {} , "", $(this).data('url'));
    });

    const between = (x, min, max) => {
        return x >= min && x <= max;
    }

    const lotsAreaFilter = (from, to) => {
        let $lots = $('.lot'),
            activeLots = [];
        $lots.each(function() {
            const area = $(this).data('area');
            if(area && between(area, from, to)) {
                 activeLots.push($(this));
            }
        });

        return activeLots;
    }

    const lotsStatusFilter = (statuses) => {
        let $lots = $('.lot'),
            activeLots = [];

        $lots.each(function() {
            if($(this).is(statuses.join(', '))) {
                activeLots.push($(this));
            }
        });

        return activeLots;
    }

    const lotsFilter = (activeLots) => {

        const $lots = $('.lot');

        if(!activeLots.length) {
            $lots.removeClass('disabled selected animate__fadeIn');
            return;
        }

        $lots.removeClass('selected animate__fadeIn').addClass('disabled');

        activeLots.forEach(id => {
            $lots.each(function() {
                if($(this).data('id') == id) {
                    $(this).removeClass('disabled').addClass('selected animate__fadeIn');
                }
            });
        });

    }

    $('.legend-item').click(function() {
        let $lots = $('.lot'),
            status = $(this).data('status');

        if($(this).hasClass('active')) {
            $('.legend-item').removeClass('active disabled');
            $lots.removeClass('disabled selected animate__fadeIn');
            return;
        }

        $('.legend-item').not(this).addClass('disabled').removeClass('active');
        $(this).removeClass('disabled').addClass('active');

        lotsStatusFilter(status);

    });


    $('.filter-input').change(function(e) {
        e.stopPropagation();
        e.preventDefault();

        const $form = $('form.lots-filter'),
              url = $form.attr('action');

              console.log($form, url)

        $.ajax({
            url: url,
            type: 'GET',
            data: $form.serialize(),
            success: function (response) {
                lotsFilter(response);
            },
            error: function (jqXHR, textStatus, errorThrown) {
            }
        });


    });

    $('.lots-choose').click(function(e) {
        let $svg = $('.lands-svg'),
            $filterBtn = $('.lots-filter-btn'),
            $area = $('.svg-area'),
            scroll = ($area.width() - $(window).width()) / 2;

        $('.lots-mobile-wrap').hide();
        $area.show();
        $filterBtn.addClass('active');
        //$svg.scrollLeft(scroll);
        lotAnimation(0);
    });

    $('.zoom-btn').click(function(e) {
        let $svg = $('.lands-svg'),
            $title = $('.lots-title'),
            $area = $('.svg-cont');

        $(this).toggleClass('zoomed');
        $svg.toggleClass('zoomed').scrollLeft(0);
        $area.toggleClass('zoomed');
        $title.toggleClass('zoomed');
    });

    $('.tour-open-btn').click(function(e) {
        e.preventDefault();
        let target = $(this).data('target'),
            $cont = $(target);

        $cont.fadeIn(300);
    })

    $('.tour-close-btn').click(function(e) {
        e.preventDefault();
        let target = $(this).data('target'),
            $cont = $(target);

        $cont.fadeOut(300);
    })

    $('.lots-filter-btn').click(function(e) {
        $('.lots-filter-checkbox-modal').slideDown(500, 'easeOutExpo');
    });

    $('.checkbox-modal-header').click(function(e) {
        $(this).parent('.lots-filter-checkbox-modal').slideUp(300);
    });

    $('.swiper-pagination-btn').click(function(e) {
        $('.district-slider-pagination-cont').slideDown(500, 'easeOutExpo');
    });

    $('.district-slider-pagination-header, .swiper-pagination-bullet').click(function(e) {
        if(!isMobile()) return;
        $(this).parents('.district-slider-pagination-cont').slideUp(300);
    });

    $('.checkbox-modal-btn').click(function(e) {
        e.preventDefault();
        let url = $(this).data('url'),
            $form = $('.checkbox-modal-items'),
            $cont = $('.lots-item-cont'),
            checkedArea = $(".lots-filter-checkbox-modal input:checkbox:checked").map(function(){
                return $(this).val().split('-');
            }).get(),
            sortedCheckedArea = checkedArea.sort(function(a, b){return a-b}),
            filterFrom = parseInt(sortedCheckedArea[0]),
            filterTo = parseInt(sortedCheckedArea[sortedCheckedArea.length - 1]);
        if(!checkedArea.length) return;

        $cont.empty();

        $.ajax({
            url: url,
            type: 'GET',
            data: {
                from: filterFrom,
                to: filterTo,
            },
            success: function (response) {
                $('body').addClass('lot-open');
                $form.trigger("reset");
                $cont.append(response);
                $('.lots-filter-checkbox-modal').slideUp(300);
            },
            error: function (jqXHR, textStatus, errorThrown) {
                $form.trigger("reset");
                $('body').removeClass('lot-open');
                $cont.empty();
            }
        });

    });


let facebookShare = function (shareUrl) {
    let url = 'https://www.facebook.com/sharer/sharer.php?display=popup&u=' + shareUrl;
    let options = 'toolbar=0,status=0,resizable=1,width=626,height=436';
    window.open(url, 'sharer', options);
}


let emailShare = function (shareUrl) {
    let url = 'mailto:?body=' + shareUrl;
    window.open(url);
}

let viberShare = function (shareUrl) {
    let url = 'viber://forward?text=' + shareUrl;
    let options = 'toolbar=0,status=0,resizable=1,width=626,height=436';
    window.open(url, 'sharer', options);
}

let whatsappShare = function (shareUrl) {
    let url = 'whatsapp://send?text=' + shareUrl;
    let options = 'toolbar=0,status=0,resizable=1,width=626,height=436';
    window.open(url, 'sharer', options);
}

let clipboard = new ClipboardJS('.copy-link');

clipboard.on('success', function (e) {
    $(e.trigger).popover('show');
    setTimeout(function () {
        $(e.trigger).popover('hide');
    }, 3000);
    e.clearSelection();
});

$(document).on('click', '.share-icon', function (e) {

    let $dataTarget = $(this).data('target'),
        url = $(this).data('url');

    switch ($dataTarget) {
        case 'facebook':
            return facebookShare(url)
            break;

        case 'mailto':
            return emailShare(url)
            break;

        case 'viber':
            return viberShare(url)
            break;

        case 'whatsapp':
            return whatsappShare(url)
            break;

        default:
            return;
    }

});

    $('html, body').click( function (e) {
        if (!$(e.target).hasClass('popover') && $(e.target).parents('.popover').length == 0) {
            $('.info-icon').popover('hide');
        }
    });

    $('.form-validation').parsley();

    $('.switch-container-btn').click(function(e){
        e.preventDefault();
        const target = $(this).data('target'),
              $cont = $(target);
              $('.switch-container').removeClass('active animate__fadeIn');
              $cont.addClass('active animate__fadeIn');

        if(target == '.project-lots-map-container') {
            window.initMap();
            $('.markers-checkbox, .path-checkbox').trigger('change');
        }
    });

    $('.markers-checkbox').change(function(e){
        const checked = $(this).is(':checked');

        if(checked) {
            window.showMarkers();
        } else {
            window.hideMarkers()
        }
    });

    $('.additional-markers-checkbox').change(function(e){
        const checked = $(this).is(':checked');

        if(checked) {
            window.showAdditionalMarkers();
        } else {
            window.hideAdditionalMarkers()
        }
    });

    $('.contact-form').submit(function(e){
        e.preventDefault();

        const target = $(this).attr('action'),
              $form = $('.contact-form'),
              $message = $('.contact-message');

            $.ajax({
                url: target,
                type: 'POST',
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                },
                data: $(this).serialize(),

                success: function (response) {
                    $form[0].reset();
                    $form.hide();
                    $message.fadeIn();

                    if(window.dataLayer && window.dataLayer.push) {
                        dataLayer.push({
                            'event': 'form-submission',
                            'eventAction': 'submit',
                            'eventCategory': 'contact-form',
                            'eventLabel': document.title,
                            'eventValue': new Date().getTime()
                        });
                    }

                },
                error: function (jqXHR, textStatus, errorThrown) {
                    $form[0].reset();
                }
            });
        });


    $('.timeline-circle').click(function(e) {
        e.preventDefault();

        const $item = $(this),
                $bar = $($item.data('bar')),
                itemIndex = $(this).parents('.timeline-content-item').index(),
                $dataContainer = $('.timeline-item-data'),
                offset = $item.offset().left - $('.timeline-content').offset().left,
                progress = (offset * 100) / $('.timeline-content').width();

        if($item.hasClass('disabled')) return;

        if(isMobile()) {
            let data = $(this).parent().html();
            $dataContainer.stop().fadeOut(0).html(data).fadeIn(600);
        }

        $('.timeline-circle, .animated-img').addClass('fadeOutUp').removeClass('active fadeInDown');

        $('.timeline-circle').each(function(index){
                                if(index <= itemIndex) {
                                    $(this).addClass('active');
                                    $('.animated-img[data-id="'+index+'"]').addClass('active fadeInDown');
                                }
                            });

    })

    $('#activeLot, #activeMap, #activeModal').trigger('click');


  var $modal = $('#customModal');
  var $openBtn = $('#openCustomModalBtn');
  var $closeBtn = $('#closeCustomModalBtn');
  console.log('Modal elements check:', {
    modal: $modal.length,
    openBtn: $openBtn.length,
    closeBtn: $closeBtn.length
  });
  var MODAL_HASH = {
    location: 'location',
    partners: 'partners',
    projects: 'projects'
  };

  var getHashValue = function getHashValue() {
    return (window.location.hash || '').replace(/^#/, '');
  };

  var setHashValue = function setHashValue(value) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref$replace = _ref.replace,
        replace = _ref$replace === void 0 ? false : _ref$replace;

    var nextHash = value ? '#' + value : '';
    if (window.location.hash === nextHash) return;
    var nextUrl = window.location.pathname + window.location.search + nextHash;

    if (replace) {
      history.replaceState(null, null, nextUrl);
    } else {
      history.pushState(null, null, nextUrl);
    }
  };

  var openCustomModal = function openCustomModal() {
    if (!$modal.length) return;
    $modal.removeClass('modal-closed').addClass('modal-opened');
  };

  var closeCustomModal = function closeCustomModal() {
    if (!$modal.length) return;
    $modal.removeClass('modal-opened').addClass('modal-closed');
  };

  var scrollToBannersSection = function scrollToBannersSection() {
    var $bannersSection = $('section[data-anchor="banners"]');

    if ($bannersSection.length) {
      isProgrammaticScroll = true;
      var elementTop = $bannersSection.offset().top;
      var elementHeight = $bannersSection.outerHeight();
      var windowHeight = $(window).height();
      var scrollPosition = elementTop - windowHeight / 2 + elementHeight / 2;
      $('body,html').stop().animate({
        scrollTop: scrollPosition
      }, 1000, 'easeInOutExpo', function () {
        setTimeout(function () {
          isProgrammaticScroll = false;
        }, 300);
      });
    }
  };

  var syncModalsToHash = function syncModalsToHash() {
    var hash = getHashValue();

    if (hash === MODAL_HASH.location) {
      if ($('#bannerModalLocation').length) {
        scrollToBannersSection();
        $('#bannerModalLocation').modal('show');
      }

      closeCustomModal();
      return;
    }

    if (hash === MODAL_HASH.partners) {
      if ($('#bannerModalPartners').length) {
        scrollToBannersSection();
        $('#bannerModalPartners').modal('show');
      }

      closeCustomModal();
      return;
    }

    if (hash === MODAL_HASH.projects) {
      scrollToBannersSection();
      openCustomModal();
      if ($('#bannerModalLocation').length) $('#bannerModalLocation').modal('hide');
      if ($('#bannerModalPartners').length) $('#bannerModalPartners').modal('hide');
      return;
    }

    if (hash) {
      var $anchor = $('section[data-anchor="' + hash + '"]');
      var $byId = $('#' + hash);
      var $target = $anchor.length ? $anchor : $byId;

      if ($target.length) {
        if ($('#bannerModalLocation').length) $('#bannerModalLocation').modal('hide');
        if ($('#bannerModalPartners').length) $('#bannerModalPartners').modal('hide');
        closeCustomModal();
        isProgrammaticScroll = true;
        var elementTop = $target.offset().top;
        var elementHeight = $target.outerHeight();
        var windowHeight = $(window).height();
        var scrollPosition = elementTop - windowHeight / 2 + elementHeight / 2;
        $('body,html').stop().animate({
          scrollTop: scrollPosition
        }, 1000, 'easeInOutExpo', function () {
          setTimeout(function () {
            isProgrammaticScroll = false;
          }, 300);
        });
        return;
      }
    }

    if ($('#bannerModalLocation').length) $('#bannerModalLocation').modal('hide');
    if ($('#bannerModalPartners').length) $('#bannerModalPartners').modal('hide');
    closeCustomModal();
  };

  syncModalsToHash();
  window.addEventListener('hashchange', syncModalsToHash);

  if ($modal.length && $openBtn.length && $closeBtn.length) {
    $openBtn.removeAttr('data-toggle data-target');
    $openBtn.on('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      scrollToBannersSection();
      openCustomModal();
      setHashValue(MODAL_HASH.projects);
      return false;
    });
    $closeBtn.on('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      closeCustomModal();
      if (getHashValue() === MODAL_HASH.projects) setHashValue('', {
        replace: true
      });
      return false;
    });
  } else {
    console.warn('Custom modal elements not found on page');
  } // Handle Bootstrap modals - bannerModalLocation


  $('#bannerModalLocation').on('show.bs.modal', function () {
    scrollToBannersSection();
  });
  $('#bannerModalLocation').on('shown.bs.modal', function () {
    if (getHashValue() !== MODAL_HASH.location) setHashValue(MODAL_HASH.location);
  });
  $('#bannerModalLocation').on('hidden.bs.modal', function () {
    if (getHashValue() === MODAL_HASH.location) setHashValue('', {
      replace: true
    });
  });
  $('#bannerModalPartners').on('show.bs.modal', function () {
    scrollToBannersSection();
  });
  $('#bannerModalPartners').on('shown.bs.modal', function () {
    if (getHashValue() !== MODAL_HASH.partners) setHashValue(MODAL_HASH.partners);
  });
  $('#bannerModalPartners').on('hidden.bs.modal', function () {
    if (getHashValue() === MODAL_HASH.partners) setHashValue('', {
      replace: true
    });
  });


});
